import QrCodeGenerator from "../360View/QRCodeGenerator"
const columns = [
    {
        name: 'Company',
        selector: (row) => row.company,
    },
    {
        name: 'Name',
        selector: (row) => row.name,
    },
    {
        name : "Qr Code",
        selector: (row) =><QrCodeGenerator id={row._id} size={50} />
    },
    {
        name: 'Action',
        selector: (row) => row.actions,
    }
]

export default columns